import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen pt-32 pb-24 px-6 md:px-12" data-testid="refund-policy-page">
      <SEO title="Refund Policy" description="3T refund policy. We aim to make every purchase a positive experience." />
      <div className="max-w-[900px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="font-mono text-[#FFD700] text-sm tracking-[0.3em] mb-2">SUPPORT</p>
          <h1 className="font-heading text-5xl md:text-7xl tracking-tight uppercase leading-[0.9]">
            REFUND <span className="text-[#FFD700]">POLICY</span>
          </h1>
        </motion.div>

        <div className="space-y-10 text-[#C0C0C0] text-base leading-relaxed">
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}
            className="text-xl md:text-2xl text-white font-medium leading-relaxed">
            We aim to make every purchase a positive experience.
          </motion.p>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}
            className="space-y-6">
            <p>Refunds may be issued for eligible returns in accordance with Australian Consumer Law.</p>
            <p>Refund requests are assessed once returned items have been received and inspected.</p>
            <p>Refunds will be processed using the original payment method.</p>
            <p>Shipping charges are non-refundable unless the item is faulty or the error was ours.</p>
            <p>Items showing signs of wear, washing, or misuse may not qualify for a refund.</p>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}
            className="border-l-4 border-[#FFD700] pl-6 py-4">
            <p className="font-heading text-lg text-white mb-1">If you have any questions, please contact:</p>
            <a href="mailto:hello@think3t.com.au" className="font-mono text-[#FFD700] hover:underline">hello@think3t.com.au</a>
          </motion.div>

          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }}
            className="text-[#A3A3A3] text-sm">
            See also: <Link to="/returns" className="text-[#FFD700] hover:underline">Returns & Exchanges</Link> · <Link to="/shipping" className="text-[#FFD700] hover:underline">Shipping</Link> · <Link to="/terms" className="text-[#FFD700] hover:underline">Terms & Conditions</Link>
          </motion.p>
        </div>
      </div>
    </div>
  );
}
